import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Descriptions, Button, message } from 'antd';
import { UserOutlined, MailOutlined, PhoneOutlined, LogoutOutlined } from '@ant-design/icons';
import { authAPI } from '../services/api';
import { requireAuth, logout } from '../utils/auth';
import './Profile.css';

function Profile() {
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!requireAuth(navigate)) return;
    loadUserInfo();
  }, []);

  const loadUserInfo = async () => {
    setLoading(true);
    try {
      const res = await authAPI.getCurrentUser();
      setUserInfo(res.data);
    } catch (error) {
      message.error('加载用户信息失败');
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    logout();
    message.success('已退出登录');
  };

  if (loading) {
    return <div className="loading-container">加载中...</div>;
  }

  if (!userInfo) {
    return null;
  }

  return (
    <div className="profile-container">
      <h1 className="page-title">个人中心</h1>

      <Card title="基本信息" className="profile-card">
        <Descriptions column={1} bordered>
          <Descriptions.Item
            label={
              <span className="label-with-icon">
                <UserOutlined /> 用户名
              </span>
            }
          >
            {userInfo.username}
          </Descriptions.Item>

          <Descriptions.Item
            label={
              <span className="label-with-icon">
                <MailOutlined /> 邮箱
              </span>
            }
          >
            {userInfo.email}
          </Descriptions.Item>

          <Descriptions.Item
            label={
              <span className="label-with-icon">
                <PhoneOutlined /> 手机号
              </span>
            }
          >
            {userInfo.phone || '未设置'}
          </Descriptions.Item>

          <Descriptions.Item label="注册时间">
            {new Date(userInfo.created_at).toLocaleString('zh-CN')}
          </Descriptions.Item>
        </Descriptions>

        <div className="profile-actions">
          <Button onClick={() => navigate('/orders')}>
            我的订单
          </Button>
          <Button
            danger
            icon={<LogoutOutlined />}
            onClick={handleLogout}
          >
            退出登录
          </Button>
        </div>
      </Card>
    </div>
  );
}

export default Profile;
